import React from 'react';
import PropTypes from 'prop-types';
import './ChatsListItems.css';
import verified from '../../assets/badge-influencer.svg';
import online from '../../assets/online-icon.svg';

const ChatsListItem = ({
  image,
  name,
  username,
  badge,
  message,
  time,
  available,
}) => {
  return (
    <div className="flex flex-ai-c mb-1 chatlists">
      <div className="image image--flex">
        <img src={image} alt={name} />
      </div>
      <div className="message__info message__info--flex">
        <div className="flex flex-ai-c ellipsis message__user--chat">
          <h5>{name}</h5>
          {badge && (
            <img className="message__badge" src={verified} alt="badge" />
          )}
          <p>{username}</p>
        </div>
        <div className="message__content--chat">
          <p>{message}</p>
        </div>
      </div>
      <div className="right right--flex">
        <p className="time">{time}</p>
        {available && (
          <img className="online__badge" src={online} alt="online" />
        )}
      </div>
      <div className="line" />
    </div>
  );
};

ChatsListItem.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  username: PropTypes.string,
  badge: PropTypes.bool,
  message: PropTypes.string,
  time: PropTypes.string,
  available: PropTypes.bool,
};

ChatsListItem.defaultProps = {
  image:
    'https://i0.wp.com/www.repol.copl.ulaval.ca/wp-content/uploads/2019/01/default-user-icon.jpg',
  name: 'Laolu nifade',
  username: '#islaolu',
  badge: false,
  message: 'Did you see the penalty by me and Ronaldo masterclass!!!',
  time: '3pm',
  available: false,
};

export default ChatsListItem;
